<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import ticketService from 'api/ticket'
import PAYMENT_TYPES from 'constants/bookingPaymentTypes'
import eventBus from 'lib/eventBus'
import INVENTORY_TYPES from 'constants/inventoryTypes'

export default {
  name: 'checkout-complete',
  data() {
    return {
      PAYMENT_TYPES,
      ticketsLoading: false,
      tickets: null,
      carouselOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        scrollLock: true,
        draggable: true,
      },
    }
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      user: (state) => state.user.current,
      venue: (state) => state.venue.current,
      booking: (state) => state.checkout.booking,
    }),
  },
  methods: {
    getTickets() {
      this.ticketsLoading = true

      return ticketService.listByBookingId(this.booking.id).then((results) => {
        this.tickets = results
      })
    },
  },
  mounted() {
    if (this.booking && (this.booking.inventoryType === INVENTORY_TYPES.TICKET || this.booking.inventoryType === INVENTORY_TYPES.PICK_UP_TIME || this.booking.pickUpTimeInventory)) {
      this.getTickets()
    }

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  },
  updated() {
    eventBus.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/CheckoutComplete/index.vue